/*
  ecx-product-page redesign behaviour (loaded only on that template, see
  sections/main-product.liquid). Builds on Minimog's own events rather than
  replacing anything:
  - `${productId}__VARIANT_CHANGE` -> option cards, Buy now total
  - qty input / Seal selling_plan input changes -> Buy now total
  Prices are set via innerHTML: the shop's money_format wraps amounts in
  <span class=money> (used by the currency converter app).
  - [data-ecx-buy-now] -> /cart/add.js with the product form's data, then /checkout
*/
(function () {
  function init() {
    const root = document.querySelector('.ecx-pdp');
    const dataEl = root && root.querySelector('[data-ecx-pdp-data]');
    if (!root || !dataEl || !window.MinimogEvents) return;

    const data = JSON.parse(dataEl.textContent);
    const format = (cents) =>
      typeof formatMoney === 'function' ? formatMoney(cents, data.moneyFormat) : (cents / 100).toFixed(2);
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    let current = data.variants.find((v) => String(v.id) === String(form && form.querySelector('[name="id"]').value)) || data.variants[0];

    const qty = () => {
      const input = form && form.querySelector('[name="quantity"]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    };
    const unitPrice = () => {
      const plan = form && form.querySelector('[name="selling_plan"]');
      const planId = plan && plan.value;
      return planId && current.plans[planId] != null ? current.plans[planId] : current.price;
    };

    function updateTotal() {
      root.querySelectorAll('[data-ecx-total]').forEach((el) => (el.innerHTML = format(unitPrice() * qty())));
    }

    // Size cards show the variant each one would select given the other
    // currently selected options - refresh them when e.g. Type changes.
    function updateCards() {
      const pickers = root.querySelectorAll('.ecx-option-cards');
      const last = pickers[pickers.length - 1];
      if (!last) return;
      last.querySelectorAll('.m-product-option--node').forEach((node) => {
        const position = Number(node.dataset.optionPosition);
        const options = current.options.slice();
        options[position - 1] = node.dataset.value;
        const match = data.variants.find((v) => v.options.every((o, i) => o === options[i]));
        const price = node.querySelector('[data-ecx-card-price]');
        const badge = node.querySelector('[data-ecx-card-badge]');
        if (price) price.innerHTML = match ? format(match.price) : '';
        if (badge) {
          badge.hidden = !(match && match.badge);
          badge.textContent = match ? match.badge : '';
        }
      });
    }

    window.MinimogEvents.subscribe(`${data.productId}__VARIANT_CHANGE`, (variant) => {
      if (!variant) return;
      current = data.variants.find((v) => v.id === variant.id) || current;
      updateCards();
      updateTotal();
      const buyNow = root.querySelector('[data-ecx-buy-now]');
      if (buyNow) {
        buyNow.disabled = !variant.available;
        buyNow.classList.toggle('disabled', !variant.available);
      }
    });

    if (form) {
      // Seal Subscriptions swaps the selling_plan input inside the form; qty
      // buttons fire change on the input. Listen at the form so both are caught.
      form.addEventListener('change', updateTotal);
      form.addEventListener('input', updateTotal);
      form.addEventListener('click', () => setTimeout(updateTotal, 0));
    }

    // Keep the template's Add-to-cart label: the theme resets button text to
    // MinimogStrings.addToCart (the shop-wide locale, "Buy Now") on every
    // variant change, for both the main and the sticky add-to-cart button.
    const atcButton = form && form.querySelector('.m-add-to-cart');
    const atcLabel = atcButton && atcButton.dataset.atcText;
    if (atcLabel && window.MinimogStrings) {
      window.MinimogStrings.addToCart = atcLabel;
      root.querySelectorAll('.m-add-to-cart').forEach((btn) => {
        btn.dataset.atcText = atcLabel;
        const text = btn.querySelector('.m-add-to-cart--text');
        if (text && !btn.classList.contains('disabled')) text.textContent = atcLabel;
      });
    }

    const buyNow = root.querySelector('[data-ecx-buy-now]');
    if (buyNow && form) {
      buyNow.addEventListener('click', async () => {
        const message = form.querySelector('.m-product-form-message');
        buyNow.classList.add('m-spinner-loading');
        try {
          const body = new FormData(form);
          body.set('id', current.id);
          const res = await fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
          window.location.href = '/checkout';
        } catch (err) {
          buyNow.classList.remove('m-spinner-loading');
          if (message) {
            message.textContent = err.message;
            message.style.display = 'block';
          }
        }
      });
    }

    root.querySelectorAll('[data-ecx-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Sticky left column (desktop): if gallery + spec table is taller than
    // the viewport, offset `top` so its bottom stays reachable.
    const mediaCol = root.querySelector('.m-main-product--media');
    if (mediaCol && 'ResizeObserver' in window) {
      const setTop = () => {
        const gap = 30;
        const overflow = mediaCol.offsetHeight + gap * 2 - window.innerHeight;
        mediaCol.style.setProperty('--ecx-media-top', `${overflow > 0 ? gap - overflow : gap}px`);
      };
      new ResizeObserver(setTop).observe(mediaCol);
      window.addEventListener('resize', setTop);
      setTop();
    }

    updateTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
